import { useEffect, useState } from 'react'
import { RefreshCw } from 'lucide-react'

/**
 * „Aplicatia a fost actualizata — reincarca." Un tab deschis inainte de publicare ruleaza codul
 * vechi pana la reincarcare si poate trimite API-ului nou cereri pe care nu le mai intelege
 * (13.10.2026: fereastra veche de task din Inbox, la Victor, dupa trecerea pe departamente).
 *
 * Verifica `versiune.json` (scris la build, vezi `vite.config.ts`) la 5 minute si cand revii in
 * tab. Nu reincarca singur: omul poate avea un formular pe jumatate completat.
 */
const LA_FIECARE_MS = 5 * 60_000

/**
 * Versiunea din build. `typeof`, nu acces direct: o configurare Vite fara `define` (un server de
 * test, o unealta) n-are variabila, iar un acces direct ar opri TOATA aplicatia dintr-un aviz.
 */
const VERSIUNEA_MEA = typeof __VERSIUNE__ === 'string' ? __VERSIUNE__ : 'dev'

async function versiuneaDePeServer(): Promise<string | null> {
  try {
    const r = await fetch(`/versiune.json?t=${Date.now()}`, { cache: 'no-store' })
    if (!r.ok) return null
    const j = (await r.json()) as { versiune?: unknown }
    return typeof j.versiune === 'string' ? j.versiune : null
  } catch {
    return null
  }
}

export function AvizVersiuneNoua() {
  const [noua, setNoua] = useState(false)

  useEffect(() => {
    if (VERSIUNEA_MEA === 'dev') return
    let oprit = false
    const verifica = async () => {
      const v = await versiuneaDePeServer()
      if (!oprit && v && v !== VERSIUNEA_MEA) setNoua(true)
    }
    const laVizibil = () => document.visibilityState === 'visible' && void verifica()
    // O bucata de cod incarcata la cerere (o pagina) nu mai exista pe server dupa publicare.
    const laEroareIncarcare = () => setNoua(true)
    const t = window.setInterval(verifica, LA_FIECARE_MS)
    document.addEventListener('visibilitychange', laVizibil)
    window.addEventListener('vite:preloadError', laEroareIncarcare)
    void verifica()
    return () => {
      oprit = true
      window.clearInterval(t)
      document.removeEventListener('visibilitychange', laVizibil)
      window.removeEventListener('vite:preloadError', laEroareIncarcare)
    }
  }, [])

  if (!noua) return null
  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-0 z-[60] flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 border-t border-b4l-blue bg-b4l-blue-light px-4 py-2.5 text-corp text-b4l-blue-dark shadow-panou"
    >
      <span>
        <b>Aplicația a fost actualizată.</b> Reîncarcă pagina ca să lucrezi pe versiunea nouă.
      </span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="inline-flex items-center gap-1.5 rounded-caseta bg-b4l-blue px-3 py-1.5 font-medium text-b4l-pe-accent hover:brightness-110"
      >
        <RefreshCw size={14} aria-hidden="true" /> Reîncarcă
      </button>
    </div>
  )
}
